module.exports = __webpack_public_path__ + "static/img/noticia13.40297939.webp";